import { ContrastQueryParameters } from '../../../graphql/schema/endpoint-helpers'
import { ThisConnector } from '../../connector'
import { ProtectRule } from '../../../components/protect-rules'
import { setExpandWithSkipLinks, normalizeProtectRule } from '../shared'

export interface CveShieldsQueryArgs {
  organizationUuid: string
  expand?: string
}

export async function getCveShieldsSummary(
  this: ThisConnector,
  { organizationUuid, expand }: CveShieldsQueryArgs
): Promise<ProtectRule[]> {
  const urlParams = new ContrastQueryParameters()
  urlParams.append('expand', setExpandWithSkipLinks(expand))

  const { rules } = await this.connector.get(
    `/${organizationUuid}/protection/rules/cve?${urlParams}`
  )

  return rules.map(normalizeProtectRule)
}
